var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftFillArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5805 2.98522C13.5805 3.14356 13.5221 3.30189 13.3971 3.42689L7.9638 8.86022C7.5638 9.26022 7.5638 9.91022 7.9638 10.3102L13.3971 15.7436C13.6388 15.9852 13.6388 16.3852 13.3971 16.6269C13.1555 16.8686 12.7555 16.8686 12.5138 16.6269L7.08047 11.1936C6.19714 10.3102 6.19714 8.86855 7.08047 7.97689L12.5138 2.54355C12.7555 2.30189 13.1555 2.30189 13.3971 2.54355C13.5138 2.66855 13.5805 2.82689 13.5805 2.98522Z",
    fill: "#E3CDFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftFillArrow);
export default __webpack_public_path__ + "static/media/left-fill-arrow.e4c6abf2f825b8e3edcea38386a9f620.svg";
export { ForwardRef as ReactComponent };